import { createFileRoute } from '@tanstack/react-router';
import UserSessionsPage from '@/features/user-sessions';

export const Route = createFileRoute('/_authenticated/user-sessions/')({
  component: UserSessionsPage,
});
